import { useState } from "react";
import { useTranslation } from "next-i18next";
import {
  AdditionalInformation,
  Column,
  DownloadRow,
} from "styles/jss/ProductsPage.styles";
import { Tabs, Tab, Box, Button } from "@mui/material";
import parse from "html-react-parser";
import { PostContent } from "../../index";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ProductItemTabs = props => {
  const { t } = useTranslation(["products"]);
  const { description, methods, markets, type, applications, downloads } =
    props;

  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%", mb: "100px" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="basic tabs example"
        >
          <Tab label={t("tab.description")} {...a11yProps(0)} />
          <Tab label={t("tab.additional-information")} {...a11yProps(1)} />
          <Tab label={t("tab.downloads")} {...a11yProps(2)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <PostContent description={description} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <AdditionalInformation>
          <Column>
            <h3 className={"title"}>{t("p-method")}</h3>
            <p className={"text"}>
              {methods?.data.map(item => item.attributes.method).join(", ")}
            </p>
          </Column>
          <Column>
            <h3 className={"title"}>{t("p-application")}</h3>
            <p className={"text"}>
              {applications?.data
                .map(item => item.attributes.application)
                .join(", ")}
            </p>
          </Column>
          <Column>
            <h3 className={"title"}>{t("p-market")}</h3>
            <p className={"text"}>
              {" "}
              {markets?.data.map(item => item.attributes.market).join(", ")}
            </p>
          </Column>
          <Column>
            <h3 className={"title"}>{t("p-type")}</h3>
            <p className={"text"}>{type.data.attributes.name}</p>
          </Column>
        </AdditionalInformation>
      </TabPanel>
      <TabPanel value={value} index={2}>
        {[...(downloads || [])].map(item => (
          <DownloadRow key={item.id}>
            <p>{item.file_name}</p>
            <Button>
              <a
                href={process.env.BASE_URL + item.file.data.attributes.url}
                download
              >
                {t("downloadBtn")}
              </a>
            </Button>
          </DownloadRow>
        ))}
      </TabPanel>
    </Box>
  );
};

export default ProductItemTabs;
